module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/InglouriousBasterds.ccdaf1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/InglouriousBasterds.jpg
// module id = qgXI
// module chunks = 0